import { buildContent } from '../authoring/index.js';
import { starterDecks } from './decks.js';
import { productionDeckPassives } from './deck-passives.js';
import { generatedGameCards } from './generated-cards.js';
export const content = buildContent({
    cards: generatedGameCards,
    deckPassives: productionDeckPassives,
    decks: starterDecks,
});
export { starterDecks } from './decks.js';
export { productionDeckPassives } from './deck-passives.js';
export { DECK_PASSIVE_RELEASES, validateDeckPassiveReleaseCoverage, } from './deck-passive-releases.js';
//# sourceMappingURL=index.js.map